import { removeLoginToken, updateChatChannelName, updateChatIdentity } from 'src/utils/helpers'

export function setUser(user) {
  return {
    type: 'SET_USER',
    payload: { user }
  }
}

export function setEmail(email) {
  return {
    type: 'SET_EMAIL',
    payload: { email }
  }
}

export function clearEmail() {
  return {
    type: 'CLEAR_EMAIL',
  }
}

export function resetUser() {

  removeLoginToken()

  // Update chat channel name and identity so that cookies can expire
  updateChatChannelName()
  updateChatIdentity()

  return {
    type: 'RESET_USER',
  }
}

export function getOtherUsers() {
  return {
    type: 'GET_OTHER_USERS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/users/vaultUserAccountList',
            mock: false
          },
        },
        commit: {
          type: 'GET_OTHER_USERS_COMMIT',
        },
        rollback: {
          type: 'GET_OTHER_USERS_ROLLBACK',
        }
      },
    },
  }
}

export function afterAddUser() {
  return (dispatch) => {
    dispatch(getOtherUsers())
  }
}

export function savePinkSlipConsent(isConfirmed, visitorData = null) {
  return {
    type: 'SAVE_PINK_SLIP_CONSENT',
    payload: {
      hasGivenSlipConsent: isConfirmed,
      visitorData: visitorData,
    },
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/me',
          },
        },
        commit: {
          type: 'SAVE_PINK_SLIP_CONSENT_COMMIT',
        },
        rollback: {
          type: 'SAVE_PINK_SLIP_CONSENT_ROLLBACK',
        }
      },
    },
  }
}

export function setSlipConsent(hasSlipConsent) {
  return {
    type: 'SET_PINK_SLIP_CONSENT',
    payload: {
      hasSlipConsent,
    }
  }
}

export function setUserLastAccessType(userLastAccessType) {
  return {
    type: 'SET_USER_LAST_ACCESS_TYPE',
    payload: {
      userLastAccessType,
    }
  }
}

export function getUserPushSettings() {
  return {
    type: 'GET_USER_NOTIFICATION_SETTINGS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            base: '/vaultUser/notificationSettings',
            mock: false
          },
        },
        commit: {
          type: 'GET_USER_NOTIFICATION_SETTINGS_COMMIT',
        },
        rollback: {
          type: 'GET_USER_NOTIFICATION_SETTINGS_ROLLBACK',
        }
      },
    },
  }
}

export function saveUserPushSettings(payload) {
  return {
    type: 'SAVE_USER_NOTIFICATION_SETTINGS',
    payload: payload,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            base: '/vaultUser/notificationSettings',
            mock: false
          },
        },
        commit: {
          type: 'SAVE_USER_NOTIFICATION_SETTINGS_COMMIT',
        },
        rollback: {
          type: 'SAVE_USER_NOTIFICATION_SETTINGS_ROLLBACK',
        }
      },
    },
  }
}
